import { FC } from 'react';
import { PieChart, Pie, Legend, Tooltip, Cell, PieLabelRenderProps } from 'recharts';

export interface PieDataItem {
  name: string;
  value: number;
  fill: string;
}

interface PieChartComponentProps {
  data: PieDataItem[];
  width: number;
  height: number;
  title: string;
  fontSize?: string;
  marginLeft?: string;
  isAnimationActive? : boolean;
}

export const PieChartComponent: FC<PieChartComponentProps> = ({
  data,
  width,
  height,
  title,
  fontSize = '12px',
  marginLeft = '0',
  isAnimationActive = true
}) => {

  const renderCustomizedLabel = (props: PieLabelRenderProps) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, percent, index } = props;
    if (cx === undefined || cy === undefined || midAngle === undefined ||
        innerRadius === undefined || outerRadius === undefined || percent === undefined) {
      return null;
    }

    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    if (percent * 100 < 5) {
      return null;
    }

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: '10px' }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <PieChart width={width} height={height}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={90}
        dataKey="value"
        innerRadius={50}
        startAngle={90}
        endAngle={-270}
        isAnimationActive={isAnimationActive}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
      </Pie>
      <Tooltip />
      <Legend
        layout="vertical"
        align="right"
        verticalAlign="middle"
        wrapperStyle={{ fontSize, marginLeft }}
        content={({ payload }) => {
          if (!payload) return null;

          return (
            <>
              <p style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
                {title}
              </p>
              <ul style={{ listStyle: 'none', margin: 0, padding: 0, marginLeft: '20px' }}>
                {payload.map((entry, index) => {
                  const itemPayload = (entry as { payload?: PieDataItem }).payload;
                  if (!itemPayload?.fill) return null;

                  return (
                    <li key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                      <div
                        style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: itemPayload.fill,
                          marginRight: '8px',
                        }}
                      />
                      <span style={{ fontSize: '12px' }}>{entry.value}</span>
                    </li>
                  );
                })}
              </ul>
            </>
          );
        }}
      />
    </PieChart>
  );
};
